<template>
  <div :class="classes">
    <div class="sl-amap"></div>
    <slot></slot>
  </div>
</template>
<script>
import protoComponent from './proto'
import loader from '../utils/loader'
let count = 0

export default {
  name: 'SlAmap',

  extends: protoComponent,

  beforeCreate() {
    this._loadPromise = loader.load()
  },

  destroyed() {
    this.$amap && this.$amap.destroy()
  },

  data() {
    return {
      fullscreen:false
    }
  },

  props: {
    theme: {
      type: String,
      default: 'normal'
    },
    zoom: {
      type: Number,
      default: 10
    },
    center: {
      type: Array,
      default: function(){
        return []
      },
      class: 'latlng'
    },
    viewMode: {
      type: String,
      default: '2D'
    },
    animateEnable: {
      type: Boolean,
      default: true
    },
    resizeEnable:{
      type: Boolean,
      default: false
    },
    pitch:{
      type:Number,
      default:50
    }
  },

  computed:{
    classes(){
      return ['sl-amap-container' , this.fullscreen ? 'fullscreen' : '']
    }
  },
  mounted() {
    this.createMap();

  },

  methods: {
    createMap() {
      this._loadPromise.then(() => {
        AMap.Map.prototype.lngLatToPixel = AMap.Map.prototype.lnglatToPixel


        let el = this.$el.querySelector('.sl-amap')
        const id = `sl_amap_${count++}`

        el.id = id
        let options = {}
        if (this.zoom) options['zoom'] = this.zoom
        if (this.center && this.center.length == 2) options['center'] = this.center
        if (this.viewMode) options['viewMode'] = this.viewMode

        if (this.viewMode == '3D') {
          options['buildingAnimation'] = true
          options['pitchEnable'] = true
          options.pitch = this.pitch
        }

        if (this.theme) {
          options['mapStyle'] = "amap://styles/" + this.theme
        }
        options.animateEnable = this.animateEnable
        options.resizeEnable = this.resizeEnable
        // console.log(options)

        this.$amap = this.$amapComponent = new AMap.Map(id, options)
        this.$nextTick(() => {
          this.$emit('ready', this.$amap);
          this.$children.forEach(component => {
            component.$emit('ready', this.$amap);
          });
        })

      });
    },

    $initComponent(options) {
      return this.$amap
    },

    getMap() {
      return this.$amap
    },

    setStyle(v) {
      let styleName = "amap://styles/" + v
      this.$amap.setMapStyle(styleName)
    },

    setFullscreen(flag) {
      this.fullscreen = flag
    },

    $setCenter(position) {
      this.$amap.setCenter(position);

      // setTimeout(() => {
      //   this.$amap.setCenter(position);
      // }, 100)
    }
  }
};

</script>
<style lang="scss">
.sl-amap-container {
  position:relative;
  width:100%;
  height: 100%;

  &.fullscreen{
    position:fixed;
    top:0;left:0;
    z-index: 1;
    width:100% !important;
    height: 100% !important;
  }
  .sl-amap {
    position:relative;
    width:100%;
    height: 100%;
  }
}

</style>
